export default __webpack_public_path__ + "static/media/oyebamiji.1532cc60.png";